import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityFeatures = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'Multi-Factor Authentication',
      description: 'Enhanced MFA with time-based tokens',
      color: '#3b82f6'
    },
    {
      icon: 'Lock',
      title: 'Advanced CAPTCHA',
      description: 'reCAPTCHA v3 with elevated thresholds',
      color: '#10b981'
    },
    {
      icon: 'Eye',
      title: 'Session Monitoring',
      description: 'Real-time activity tracking',
      color: '#f59e0b'
    },
    {
      icon: 'AlertTriangle',
      title: 'Auto-Lockout Protection',
      description: 'Progressive delays after failed attempts',
      color: '#ef4444'
    }
  ];

  return (
    <div className="space-y-3">
      <h3 className="text-sm font-semibold text-gray-300 uppercase tracking-wider">
        Enhanced Security Features
      </h3>
      <div className="grid grid-cols-1 gap-3">
        {securityFeatures?.map((feature, index) => (
          <div
            key={index}
            className="flex items-start gap-3 p-3 rounded-lg bg-white/5 border border-white/10 hover:bg-white/10 transition-colors duration-250"
          >
            <div className="w-8 h-8 rounded-lg flex items-center justify-center flex-shrink-0" style={{
              backgroundColor: `${feature?.color}20`,
              borderColor: `${feature?.color}40`,
              borderWidth: '1px'
            }}>
              <Icon name={feature?.icon} size={16} color={feature?.color} />
            </div>
            <div className="flex-1 min-w-0">
              <div className="text-sm font-semibold text-white">{feature?.title}</div>
              <div className="text-xs text-gray-400 mt-0.5">{feature?.description}</div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};

export default SecurityFeatures;